import styled from 'styled-components';

import { colors, timing } from 'config/theme';

export const SubmittedWrapper = styled.div`
  > div {
    align-items: center;
    background-color: ${colors.brightGreen};
    display: flex;
    height: 0;
    justify-content: center;
    opacity: 0;
    overflow: hidden;
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 500;

    > div {
      align-items: center;
      color: white;
      display: flex;
      flex-direction: column;
      justify-content: center;

      > span {
        font-size: 24px;
        font-style: normal;
        font-weight: 700;
        line-height: 130%;
        padding-top: 21.83px;
        text-align: center;
        width: 338px;
      }
    }
  }

  .submit-transition-enter {
    height: 100vh;
    opacity: 0;
  }

  .submit-transition-enter-active {
    opacity: 1;
    transition: opacity ${timing.submitted.beg}ms;
  }

  .submit-transition-exit {
    height: 100vh;
    opacity: 1;
  }

  .submit-transition-exit-active {
    opacity: 0;
    transition: opacity ${timing.submitted.end}ms ${timing.submitted.mid}ms;
  }
`;
